module.exports = __webpack_public_path__ + "img/area.2e60dfb3.svg";